import React from 'react';
import styles from './index.module.scss';

import { Card, Table, Button } from 'react-bootstrap';

const SpecialList = (props) => {
    return (
        <Card className={styles.SpecialList}>
            <Card.Body>
                <h5>Active Specials</h5>
                <hr />
                <Table striped bordered hover>
                    <thead>
                        <tr>
                            <th>Order</th>
                            <th>Name</th>
                            <th>Image</th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>1</td>
                            <td>Iphone Repair at $29.99</td>
                            <td>http://aws.s3.iphone_repair_at_2999.jpg</td>
                            <td>
                                <Button className={styles.Button} size="sm" variant="primary">Edit</Button>
                                <Button className={styles.Button} size="sm" variant="danger">Delete</Button>
                                <Button className={styles.Button} size="sm" variant="warning">Change Order</Button>
                            </td>
                        </tr>
                        <tr>
                            <td>2</td>
                            <td>Iphone Repair at $29.99</td>
                            <td>http://aws.s3.iphone_repair_at_2999.jpg</td>
                            <td>
                                <Button className={styles.Button} size="sm" variant="primary">Edit</Button>
                                <Button className={styles.Button} size="sm" variant="danger">Delete</Button>
                                <Button className={styles.Button} size="sm" variant="warning">Change Order</Button>
                            </td>
                        </tr>
                        <tr>
                            <td>3</td>
                            <td>Iphone Repair at $29.99</td>
                            <td>http://aws.s3.iphone_repair_at_2999.jpg</td>
                            <td>
                                <Button className={styles.Button} size="sm" variant="primary">Edit</Button>
                                <Button className={styles.Button} size="sm" variant="danger">Delete</Button>
                                <Button className={styles.Button} size="sm" variant="warning">Change Order</Button>
                            </td>
                        </tr>
                    </tbody>
                </Table>
            </Card.Body>
        </Card>
    )
}

export default SpecialList;